import React from 'react';

import CopyLinkButton from './CopyLinkButton';

interface RegistrationLinksProps {
  ssoProLink: string;
  ssoStandardLink: string;
}

const RegistrationLinks = ({ ssoProLink, ssoStandardLink }: RegistrationLinksProps) => {
  return (
    <div className="mt-28 border-0 border-t border-solid border-t-grayscale-beige pt-28">
      <p className="mb-8 mt-0 font-suisse-intl text-body-sm font-light text-black">
        Copy a subscription registration link to allow users to join your subscription.
        Alternatively, you can add users below.
      </p>
      <div className="flex flex-row gap-16">
        {ssoStandardLink && (
          <CopyLinkButton
            className="text-black"
            linkToCopy={ssoStandardLink}
            label="Copy Standard seat link"
          />
        )}
        {ssoProLink && (
          <CopyLinkButton
            className="text-black"
            linkToCopy={ssoProLink}
            label="Copy Pro seat link"
          />
        )}
      </div>
    </div>
  );
};

export default RegistrationLinks;
